<template lang="html">
  <div class="h-100 pa3">
    <div class="tc pl-title mb3">
      {{ stepperTitle }}
    </div>
    <div class="tl pl-caption" style="position: relative; margin: auto">
      <div class="flex justify-center">
        <pl-button
          v-for="(title, i) in pageTitles"
          :key="title + i"
          @click.native="page = i"
          class="ph3 instruction-title tc"
          :class="{ 'selected-title': page === i }"
        >
          {{ title }}
        </pl-button>
      </div>
      <div class="flex">
        <div style="position: relative">
          <div class="center-absolute-middle">
            <pl-button class="pl-icon" @click.native="moveSlide('previous')">
              <i class="fas fa-chevron-left"></i>
            </pl-button>
          </div>
        </div>
        <div class="flex flex-grow instruction-box">
          <!-- SLOTED MATERIAL -->
          <slot :page="page" />
          <!--  -->
        </div>
        <div class="flex">
          <div style="position: relative">
            <div class="center-absolute-middle">
              <pl-button class="pl-icon" @click.native="moveSlide('next')">
                <i class="fas fa-chevron-right"></i>
              </pl-button>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center flex-grow ma3">
        <button
          v-for="(title, i) in pageTitles"
          @click="page = i"
          class="dot"
          :class="{ selected: page === i }"
        />
      </div>
    </div>
    <div class="flex justify-center">
      <pl-button @click.native="$emit('close')" class="pl-primary">
        Got it!
      </pl-button>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        page: 0,
      };
    },
    props: {
      pageTitles: {
        type: Array,
        default() {
          return [];
        },
      },
      stepperTitle: {
        type: String,
        default: 'Information',
      },
    },
    methods: {
      moveSlide(action) {
        if (action === 'previous' && this.page > 0) {
          this.page = this.page - 1;
        }
        if (action === 'next' && this.page < this.pageTitles.length - 1) {
          this.page = this.page + 1;
        }
      },
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  .center-absolute-middle
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  .dot
    margin: 3px;
    border: none;
    border-radius: 50%
    width: 15px
    height: 15px
    background-color: pl-fog
    &:active
      background-color: pl-slate
  .selected
    background-color: pl-slate
  .selected-title
    font-weight: bold

  .left-button, .right-button
    position: absolute
  .left-button
    left: 0px
    top: 50%;
    transform: translate(0%, -50%);
  .right-button
    right: 0px
    top: 50%;
    transform: translate(0%, -50%);

  .instruction-box
    min-height: 200px;

  .instruction-title.selected-title
    border-bottom: 2px solid pl-secondary
    color: pl-secondary
</style>



// WEBPACK FOOTER //
// onlineWalkthroughStepper.vue?5ea49706